import React from 'react';

import { Container } from '@mui/material';

import classes from './NgzUserProfile.module.scss';
import { angularizeWithProviders } from '../../../shared/providers';

const NgzUserProfile = () => {
  return (
    <Container>
      <h2 className={classes.title}>
        Please, log in to the LifeBase Solutions application on your device
      </h2>
    </Container>
  );
};

export { NgzUserProfile };

angularizeWithProviders(NgzUserProfile, 'ngzUserProfile', {});
